import React from 'react';
import './BackfillButton.css';

const BackfillButton = ({ onBackfill, status }) => {
    return (
        <div className="analytics-actions">
            <button 
                className="backfill-button"
                onClick={onBackfill}
                disabled={status.loading}
            >
                {status.loading ? 'Processing...' : 'Generate Analytics'}
            </button>
        </div>
    );
};

export default BackfillButton;